module.exports = __webpack_public_path__ + "static/media/undraw_visual_data_white.706008c2.svg";